const LeftSide = () => {
    return (
        <div className="w-1/2 flex flex-col bg-adq-blue text-white">
            <div className="flex flex-row w-full justify-center my-auto">
                <img
                    className="w-2/5"
                    src="/login-left-side-logo.svg"
                    alt="ADQUIVER MEDIA"
                />
            </div>
        </div>
    );
}

export default LeftSide;